import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {meshGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GetAttributeParameters} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"
import {GeometryGetAttributeNode, getAttributeParametersSchema} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"

export type MeshGeometryGetAttributeParameters = GetAttributeParameters<MeshGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryGetAttributeParameters> = {
    nodeClass: "MeshGeometryGetAttribute",
    validation: {
        parameters: getAttributeParametersSchema(meshGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryGetAttribute extends GeometryGetAttributeNode<2, MeshGeometryAttributeSetLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
